import { stringify } from 'querystring'

const baseUrl = process.env.PREACT_APP_API_URL

export const get = (url, params) => {
	return fetch(baseUrl + url + '?' + stringify(params)).then(res => res.json())
}
